export enum ContextDataModes {
  Run = 'Run',
  Debug = 'Debug',
}
